import script from "./MaintenanceMessage.vue?vue&type=script&setup=true&lang=ts"
export * from "./MaintenanceMessage.vue?vue&type=script&setup=true&lang=ts"

import "./MaintenanceMessage.vue?vue&type=style&index=0&id=2818bf1a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2818bf1a"]])

export default __exports__